import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SK_userSession } from '../../../data/config';
import { stringifyJSON } from '../../../utils/helperFunction/jsonHandler';
import getInitialUserSessionState from './helpers/getInitialUserSessionState';

// USER SESSION STORES  AUTH TOKENS
export type UserSessionType = {
  signedAccessToken?: string;
  signedRefreshPayload?: string;
};

const initialState: UserSessionType = getInitialUserSessionState();

const userSessionSlice = createSlice({
  name: 'userSession',
  initialState,
  reducers: {
    /**
     * @description setUserSession updates the userSession state in store and locally
     * @param action contains payload you want the state to be updated with
     */
    setUserSession: (state, action: PayloadAction<UserSessionType>) => {
      const stringPayload = stringifyJSON(action.payload);
      localStorage.setItem(SK_userSession, stringPayload);
      return (state = { ...action.payload });
    },

    /**
     * @description updateUserAuthToken updates the signedAccessToken state with new value in store and locally
     * @param action contains payload you want the state to be updated with
     */
    updateUserAuthToken: (
      state,
      action: PayloadAction<Pick<UserSessionType, 'signedAccessToken'>>
    ) => {
      const newUserSession: UserSessionType = {
        ...state,
        signedAccessToken: action.payload.signedAccessToken,
      };
      const stringPayload = stringifyJSON(newUserSession);
      localStorage.setItem(SK_userSession, stringPayload);
      return (state = newUserSession);
    },

    /**
     * @description clearUserSession clears stored user session both on store and locally
     */
    clearUserSession: () => {
      localStorage.removeItem(SK_userSession);
      const resetValues = {
        signedAccessToken: undefined,
        signedRefreshPayload: undefined,
      };
      return resetValues;
    },
  },
});

export const { clearUserSession, updateUserAuthToken, setUserSession } =
  userSessionSlice.actions;
const userSessionReducer = userSessionSlice.reducer;
export default userSessionReducer;
